<template>
  <div>
    <div slot="demo">
      <TabPanels type="singleCard" :tabMarginLeft="20" :tabPanels="tabPanelsData"></TabPanels>
    </div>
  </div>
</template>
<script>
import detailComponents from "./detailComponents";

export default {
  data() {
    return {
      objid: this.$route.params.customizedModuleId,
      table: this.$route.params.customizedModuleName,
      fromArray: [],
      demo: detailComponents,
      sortcc: [],
      showload: false,
      tabPanelsData: [
        {
          label: "标签1", // tab标签名字
          component: detailComponents, // tab标签里的组件
          ref: "test1", // tab标签里的组件的ref
          componentAttribute: {}, // 组件属性
          cilckCallback: (index, name, instance) => {
            console.log(index, name, instance);
          }
        }
      ]
    };
  },
  mounted() {
    this.getObjectTab();
  },
  methods: {
    getObjectTab() {
      let param = new URLSearchParams();
      param.append("table", "CP_C_CUSTOMER");
      param.append("objid", "28");
      param.append("ismaintable", "y");
      param.append("apply_table", "CL_C_CUST_OPEN");
      param.append("apply_objid", "55");
      axios({
        url: "/p/cs/scrm/objectTab",
        method: "post",
        data: param
      }).then(res => {
        if (res.data.code === 0) {
          res.data.data.reftabs.forEach((element, index) => {
            element.label = element.tabledesc;
            element.component = this.demo;
            element.tablename = element.tablename;
            element.ref = `componentsRef${index}`;

            element.componentAttribute = {};
            element.cilckCallback = (index, name, instance) => {
              this.getInputForitem(element.tablename);
              this.getObjectTableItem(element.tablename);
            };
          });
          let sortcc = res.data.data.reftabs.sort((a, b) => a.order - b.order);
          this.tabPanelsData = sortcc;
          this.getInputForitem(sortcc[0].tablename);
          this.getObjectTableItem(sortcc[0].tablename, sortcc[0].refcolid);
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: res.data.message
          });
        }
      });
    },
    getInputForitem(tableName) {
      let param = new URLSearchParams();
      param.append("table", tableName);
      param.append("inlinemode", "y");
      axios({
        url: "/p/cs/inputForitem",
        method: "post",
        data: param
      }).then(res => {
        if (res.data.code === 0) {
          this.fromArray = res.data.data.inpubobj;
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: res.data.message
          });
        }
      });
    },
    getObjectTableItem(tableName, refcolid) {
      let param = new URLSearchParams();
      param.append("table", "CP_C_CUSTOMER_ITEM");
      param.append("objid", "28");
      param.append("refcolid", "1700804996");
      param.append(
        "searchdata",
        JSON.stringify({
          startindex: 0,
          range: 10,
          column_include_uicontroller: true
        })
      );
      axios({
        url: "/p/cs/objectTableItem",
        method: "post",
        data: param
      }).then(res => {
        if (res.data.code === 0) {
          this.tabPanelsData.forEach(ele => {
            if (ele.tablename == tableName) {
              ele.componentAttribute = {
                totalRowCount: res.data.datas.totalRowCount,
                row: res.data.datas.row,
                tabth: res.data.datas.tabth,
                pageSizeOpts: res.data.datas.selectrange,
                fromArray: this.fromArray
              };
            }
          });
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: res.data.message
          });
        }
      });
    }
  }
};
</script>
<style lang="less">
</style>